/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {AvalancheServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheServerDataParser";
import {IMonkeysGoldGameData, IMonkeysGoldInitData} from "./data/IMonkeysGoldServerData";
import {IExistingBigSymbols} from "./data/IExistingBigSymbols";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class MonkeysGoldServerDataParser extends AvalancheServerDataParser {

    constructor() {
        super();
    }

    public parseUpgrade2x2Symbols(rawData:IMonkeysGoldGameData):boolean[][] {
        let parsed2x2UpgradeSymbols:boolean[][] = [];

        for(let i:number = 0; i < 6; i++) {
            let reel:boolean[] = [];
            for(let j:number = 0; j < 6; j++) {
                reel.push(false);
            }
            parsed2x2UpgradeSymbols.push(reel);
        }

        if(rawData.bigSymbolSize == 1 && rawData.existingBigSymbols.length == 0) {
            return parsed2x2UpgradeSymbols;
        }
        //Checking current response for 2x2
        if(rawData.bigSymbolSize == 2) {
            //Make sure the big symbol is left after collapse
            if(rawData.upgradePositionsAfterCollapse[rawData.bigSymbolPosition[0]][rawData.bigSymbolPosition[1]] == true &&
                rawData.upgradePositionsAfterCollapse[rawData.bigSymbolPosition[0]][rawData.bigSymbolPosition[1] - 1] == true &&
                rawData.upgradePositionsAfterCollapse[rawData.bigSymbolPosition[0] + 1][rawData.bigSymbolPosition[1]] == true &&
                rawData.upgradePositionsAfterCollapse[rawData.bigSymbolPosition[0] + 1][rawData.bigSymbolPosition[1] - 1] == true) {
                parsed2x2UpgradeSymbols[rawData.bigSymbolPosition[0]][rawData.bigSymbolPosition[1]] = true;
                parsed2x2UpgradeSymbols[rawData.bigSymbolPosition[0]][rawData.bigSymbolPosition[1] - 1] = true;
                parsed2x2UpgradeSymbols[rawData.bigSymbolPosition[0] + 1][rawData.bigSymbolPosition[1]] = true;
                parsed2x2UpgradeSymbols[rawData.bigSymbolPosition[0] + 1][rawData.bigSymbolPosition[1] - 1] = true;
            }
        }

        //Checking for existing 2x2
        const existingBigSymbols:IExistingBigSymbols[] = this.parseExistingBigSymbols(rawData);
        for(let i:number = 0; i < existingBigSymbols.length; i++) {
            if(existingBigSymbols[i].symbolSize == 2) {
                parsed2x2UpgradeSymbols[existingBigSymbols[i].bottomLeftPosition[0]][existingBigSymbols[i].bottomLeftPosition[1]] = true;
                parsed2x2UpgradeSymbols[existingBigSymbols[i].bottomLeftPosition[0]][existingBigSymbols[i].bottomLeftPosition[1] - 1] = true;
                parsed2x2UpgradeSymbols[existingBigSymbols[i].bottomLeftPosition[0] + 1][existingBigSymbols[i].bottomLeftPosition[1]] = true;
                parsed2x2UpgradeSymbols[existingBigSymbols[i].bottomLeftPosition[0] + 1][existingBigSymbols[i].bottomLeftPosition[1] - 1] = true;
            }
        }

        return parsed2x2UpgradeSymbols;
    }

    public parseUpgrade3x3Symbols(rawData:IMonkeysGoldGameData):boolean[][] {
        let parsedUpgrade3x3Symbols:boolean[][] = [];

        for(let i:number = 0; i < 6; i++) {
            let reel:boolean[] = [];
            for(let j:number = 0; j < 6; j++) {
                reel.push(false);
            }
            parsedUpgrade3x3Symbols.push(reel);
        }

        if(rawData.bigSymbolSize == 1 && rawData.existingBigSymbols.length == 0) {
            return parsedUpgrade3x3Symbols;
        }
        //Checking current response for 3x3
        if(rawData.bigSymbolSize == 3) {
            if(rawData.upgradePositionsAfterCollapse[rawData.bigSymbolPosition[0]][rawData.bigSymbolPosition[1]] == true &&
                rawData.upgradePositionsAfterCollapse[rawData.bigSymbolPosition[0]][rawData.bigSymbolPosition[1] - 1] == true &&
                rawData.upgradePositionsAfterCollapse[rawData.bigSymbolPosition[0]][rawData.bigSymbolPosition[1] - 2] == true &&
                rawData.upgradePositionsAfterCollapse[rawData.bigSymbolPosition[0] + 1][rawData.bigSymbolPosition[1]] == true &&
                rawData.upgradePositionsAfterCollapse[rawData.bigSymbolPosition[0] + 1][rawData.bigSymbolPosition[1] - 1] == true &&
                rawData.upgradePositionsAfterCollapse[rawData.bigSymbolPosition[0] + 1][rawData.bigSymbolPosition[1] - 2] == true &&
                rawData.upgradePositionsAfterCollapse[rawData.bigSymbolPosition[0] + 2][rawData.bigSymbolPosition[1]] == true &&
                rawData.upgradePositionsAfterCollapse[rawData.bigSymbolPosition[0] + 2][rawData.bigSymbolPosition[1] - 1] == true &&
                rawData.upgradePositionsAfterCollapse[rawData.bigSymbolPosition[0] + 2][rawData.bigSymbolPosition[1] - 2] == true
            ) {
                parsedUpgrade3x3Symbols[rawData.bigSymbolPosition[0]][rawData.bigSymbolPosition[1]] = true;
                parsedUpgrade3x3Symbols[rawData.bigSymbolPosition[0]][rawData.bigSymbolPosition[1] - 1] = true;
                parsedUpgrade3x3Symbols[rawData.bigSymbolPosition[0]][rawData.bigSymbolPosition[1] - 2] = true;
                parsedUpgrade3x3Symbols[rawData.bigSymbolPosition[0] + 1][rawData.bigSymbolPosition[1]] = true;
                parsedUpgrade3x3Symbols[rawData.bigSymbolPosition[0] + 1][rawData.bigSymbolPosition[1] - 1] = true;
                parsedUpgrade3x3Symbols[rawData.bigSymbolPosition[0] + 1][rawData.bigSymbolPosition[1] - 2] = true;
                parsedUpgrade3x3Symbols[rawData.bigSymbolPosition[0] + 2][rawData.bigSymbolPosition[1]] = true;
                parsedUpgrade3x3Symbols[rawData.bigSymbolPosition[0] + 2][rawData.bigSymbolPosition[1] - 1] = true;
                parsedUpgrade3x3Symbols[rawData.bigSymbolPosition[0] + 2][rawData.bigSymbolPosition[1] - 2] = true;
            }
        }

        //Checking for existing 3x3
        const existingBigSymbols:IExistingBigSymbols[] = this.parseExistingBigSymbols(rawData);
        for(let i:number = 0; i < existingBigSymbols.length; i++) {
            if(existingBigSymbols[i].symbolSize == 3) {
                parsedUpgrade3x3Symbols[existingBigSymbols[i].bottomLeftPosition[0]][existingBigSymbols[i].bottomLeftPosition[1]] = true;
                parsedUpgrade3x3Symbols[existingBigSymbols[i].bottomLeftPosition[0]][existingBigSymbols[i].bottomLeftPosition[1] - 1] = true;
                parsedUpgrade3x3Symbols[existingBigSymbols[i].bottomLeftPosition[0]][existingBigSymbols[i].bottomLeftPosition[1] - 2] = true;
                parsedUpgrade3x3Symbols[existingBigSymbols[i].bottomLeftPosition[0] + 1][existingBigSymbols[i].bottomLeftPosition[1]] = true;
                parsedUpgrade3x3Symbols[existingBigSymbols[i].bottomLeftPosition[0] + 1][existingBigSymbols[i].bottomLeftPosition[1] - 1] = true;
                parsedUpgrade3x3Symbols[existingBigSymbols[i].bottomLeftPosition[0] + 1][existingBigSymbols[i].bottomLeftPosition[1] - 2] = true;
                parsedUpgrade3x3Symbols[existingBigSymbols[i].bottomLeftPosition[0] + 2][existingBigSymbols[i].bottomLeftPosition[1]] = true;
                parsedUpgrade3x3Symbols[existingBigSymbols[i].bottomLeftPosition[0] + 2][existingBigSymbols[i].bottomLeftPosition[1] - 1] = true;
                parsedUpgrade3x3Symbols[existingBigSymbols[i].bottomLeftPosition[0] + 2][existingBigSymbols[i].bottomLeftPosition[1] - 2] = true;
            }
        }

        return parsedUpgrade3x3Symbols;
    }

    // If restore into FS intro width all rows locked we need to set the correct symbols
    public parseInitReelsRestoreIntoFS(rawData:IMonkeysGoldInitData):string[][] {
        if(((rawData.mode == GameMode.NORMAL && rawData.nextMode == GameMode.FREESPIN) || rawData.mode == GameMode.FREESPIN) && rawData.isRestoreState == true) {
            for(let i:number = 0; i < rawData.reels.length; i++) {
                for(let j:number = 0; j < rawData.reels[i].length; j++) {
                    if(rawData.reelsAfterCollapse[i][j] && rawData.reels[i][j] !== rawData.reelsAfterCollapse[i][j]) {
                        return rawData.reelsAfterCollapse;
                    }
                }
            }
        }
        return rawData.reels;
    }

    //Parsing for Colossal symbols on init
    public parseInitReelsAfterColapse(rawData:IMonkeysGoldInitData):void {
        let parsedReels:string[][] = rawData.reelsAfterCollapse;
        const existingBigSymbols:IExistingBigSymbols[] = this.parseExistingBigSymbols(rawData);
        for(let i:number = 0; i < existingBigSymbols.length; i++) {
            const colossalSymbolName:string = existingBigSymbols[i].symbol;
            const keySymReelPosition:number = existingBigSymbols[i].bottomLeftPosition[0] + (existingBigSymbols[i].symbolSize - 1);
            for(let j:number = 0; j < existingBigSymbols[i].symbolSize; j++) {
                if(existingBigSymbols[i].symbolSize == 3) {
                    parsedReels[existingBigSymbols[i].bottomLeftPosition[0] + j][existingBigSymbols[i].bottomLeftPosition[1] - 2] = colossalSymbolName + "_hidden";
                }
                parsedReels[existingBigSymbols[i].bottomLeftPosition[0] + j][existingBigSymbols[i].bottomLeftPosition[1] - 1] = colossalSymbolName + "_hidden";
                parsedReels[existingBigSymbols[i].bottomLeftPosition[0] + j][existingBigSymbols[i].bottomLeftPosition[1]] = colossalSymbolName + "_hidden";
            }
            parsedReels[keySymReelPosition][existingBigSymbols[i].bottomLeftPosition[1]] = colossalSymbolName + "_colossalx" + existingBigSymbols[i].symbolSize.toString();
        }
    }

    //Parsing for Colossal symbols and Wilds
    public parseReelData(rawData:IMonkeysGoldGameData):void {
        let parsedReels:string[][] = rawData.newSymbols;
        if(rawData.bigSymbolSize > 1) {
            const colossalSymbolName:string = rawData.bigOverlaySymbol[rawData.bigSymbolPosition[0]][rawData.bigSymbolPosition[1]];
            const keySymReelPosition:number = rawData.bigSymbolPosition[0] + (rawData.bigSymbolSize - 1);
            for(let i:number = 0; i < rawData.bigSymbolSize; i++) {
                if(rawData.bigSymbolSize == 3) {
                    parsedReels[rawData.bigSymbolPosition[0] + i][rawData.bigSymbolPosition[1] - 2] = colossalSymbolName + "_hidden";
                }
                parsedReels[rawData.bigSymbolPosition[0] + i][rawData.bigSymbolPosition[1] - 1] = colossalSymbolName + "_hidden";
                parsedReels[rawData.bigSymbolPosition[0] + i][rawData.bigSymbolPosition[1]] = colossalSymbolName + "_hidden";
            }
            parsedReels[keySymReelPosition][rawData.bigSymbolPosition[1]] = colossalSymbolName + "_colossalx" + rawData.bigSymbolSize.toString();

            //Check for up to 3 wilds under Big symbol on every Big symbol reel
            //Check for Wilds
            for(let i:number = rawData.bigSymbolPosition[0]; i < rawData.bigSymbolPosition[0] + rawData.bigSymbolSize; i++) {
                //console.log("Length of reel: " + parsedReels[i].length);
                //console.log("Bottom row position: " + rawData.bigSymbolPosition[1]);
                for(let j:number = 0; j < parsedReels[i].length - rawData.bigSymbolPosition[1]; j++) {
                    //console.log("Checking reel: " + i);
                    //console.log("Checking row: " + [rawData.bigSymbolPosition[1] + j]);
                    //console.log("Sym is: " + parsedReels[i][rawData.bigSymbolPosition[1] + j]);
                    if(parsedReels[i][rawData.bigSymbolPosition[1] + j] == "W") {
                        parsedReels[i][rawData.bigSymbolPosition[1] + j] = "W_hidden";
                    }
                }
            }
        }
    }

    public parseExistingBigSymbols(rawData:IMonkeysGoldGameData | IMonkeysGoldInitData):IExistingBigSymbols[] {
        let existingBigSymbols:IExistingBigSymbols[] = [];
        for(let existingBigSymbolsData of rawData.existingBigSymbols!) {
            existingBigSymbols.push({
                bottomLeftPosition : existingBigSymbolsData.bottomLeftPosition,
                symbol : existingBigSymbolsData.symbol,
                symbolMultiplier : existingBigSymbolsData.symbolMultiplier,
                symbolSize : existingBigSymbolsData.symbolSize,
                symbolFinalMultiplier : existingBigSymbolsData.symbolFinalMultiplier
            });
        }
        return existingBigSymbols;
    }

    public parseBigSymbolsAfterSpin(rawData:IMonkeysGoldGameData | IMonkeysGoldInitData):IExistingBigSymbols[] {
        let bigSymbolsAfterSpin:IExistingBigSymbols[] = [];
        for(let bigSymbolsAfterSpinData of rawData.bigSymbolsAfterSpin!) {
            bigSymbolsAfterSpin.push({
                bottomLeftPosition : bigSymbolsAfterSpinData.bottomLeftPosition,
                symbol : bigSymbolsAfterSpinData.symbol,
                symbolMultiplier : bigSymbolsAfterSpinData.symbolMultiplier,
                symbolSize : bigSymbolsAfterSpinData.symbolSize,
                symbolFinalMultiplier : bigSymbolsAfterSpinData.symbolFinalMultiplier
            });
        }
        return bigSymbolsAfterSpin;
    }

    public parseAvalancheTotalWin(rawData:IMonkeysGoldGameData):number {
        return parseFloat(rawData.totalBetWayWinnings);
    }

    public parseSingleWin(rawData:IMonkeysGoldGameData):number {
        return parseFloat(rawData.totalBetWayWinnings);
    }

    public parseNewWinPositions(rawData:IMonkeysGoldGameData):boolean[][] {
        let initArray:boolean[][] = JSON.parse(JSON.stringify(rawData.allWinPositions));
        if(rawData.newSymbols.length > 0) {
            for(let i:number = 0; i < rawData.newSymbols.length; i++) {
                let symsLength:number = rawData.newSymbols[i].length;
                if(symsLength < 6) {
                    for(let j:number = symsLength; j < 6; j++) {
                        initArray[i][j] = false;
                    }
                }
            }
        }
        return initArray;
    }

    public parseWinRow(rawData:IMonkeysGoldGameData):number[] {
        let initArray:number[][] = [];
        let completeRowsArray:number[] = [];
        for(let i:number = 0; i < rawData.upgradePositionsAfterCollapse.length; i++) {
            initArray[i] = [];
            for(let j:number = 0; j < rawData.upgradePositionsAfterCollapse[i].length; j++) {
                if(rawData.upgradePositionsAfterCollapse[i][j]) {
                    initArray[i].push(j);
                }
            }
        }

        for(let k:number = 0; k < 6; k++) {
            let finalArray:boolean[] = [];
            initArray.forEach((itemArray) => {
                if(itemArray.indexOf(k) > -1) {
                    finalArray.push(true);
                } else {
                    finalArray.push(false);
                }
            });

            if(!(finalArray.indexOf(false) > -1)) {
                completeRowsArray.push(k)
            }
        }
        return completeRowsArray;
    }
}